// LoadDemoButton — reusable first-run affordance that opens the LoadDemoModal.
//
// Surfaces the demo-dataset path inside empty states (CRITIQUE.md Priority 4):
// /distill demoted Load Demo out of the TopBar into a secondary menu, so
// first-run empty states are now where the demo path lives. Defaults to the
// primary visual weight to read as the recommended first-run action.

import { useState } from 'react';
import { Database } from 'lucide-react';
import { LoadDemoModal } from '../layout/LoadDemoModal';

interface Props {
  /** Optional label override. */
  label?: string;
  /** Visual variant. Defaults to primary (first-run emphasis). */
  variant?: 'primary' | 'secondary';
}

export function LoadDemoButton({ label = 'Load demo data', variant = 'primary' }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={variant === 'primary' ? 'btn btn-primary' : 'btn btn-secondary'}
        onClick={() => setOpen(true)}
      >
        <Database size={15} aria-hidden="true" /> {label}
      </button>
      <LoadDemoModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
